import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DirectDebitService } from '../services/direct-debit.service';

@Injectable()
export class DirectDebitGuard implements CanActivate {
    constructor(private directDebSrv: DirectDebitService, private router: Router) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (route.routeConfig.path === this.directDebSrv.next) {
            return true;
        } else {
            this.router.navigate(['/direct-debit/personal', 'check-for-card']);
            return false;
        }
    }
}
